import { BodyRenderItems } from '~/components/BodyRender/models';

export const renderedItemsHaveLoginRegister = (
  items: BodyRenderItems
): boolean =>
  items.some((item) => {
    const value = Object.values(item).find((val) => val);

    return (
      value?.typeName === 'LoginRegister' &&
      (value?.item[0] as { variant?: string })?.variant === 'only_signed_in'
    );
  });
